var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogomark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 32,
    viewBox: "0 0 53 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0728 25.2984V26.6318H51.9577V25.6238L51.7815 26.4935H51.662L51.4862 25.6257V26.6318H51.3707V25.2984H51.5342L51.722 26.2152L51.9097 25.2984H52.0728ZM51.0389 25.525V26.6318H50.9252V25.525H50.7158V25.2994H51.2482V25.525H51.0389Z",
    fill: "#F89E1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 28.6654H33.4147V3.53451H19.1667V28.6654Z",
    fill: "#F16522"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0844 16C20.0844 10.8959 22.5116 6.35044 26.2908 3.42082C23.5271 1.27832 20.0391 0 16.2488 0C7.27474 0 0 7.1634 0 16C0 24.8366 7.27474 32 16.2488 32C20.0391 32 23.5271 30.7217 26.2908 28.5792C22.5116 25.6496 20.0844 21.1041 20.0844 16Z",
    fill: "#E52523"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5815 16C52.5815 24.8366 45.3068 32 36.3328 32C32.542 32 29.0545 30.7217 26.2908 28.5792C30.07 25.6496 32.4971 21.1041 32.4971 16C32.4971 10.8959 30.07 6.35044 26.2908 3.42082C29.0545 1.27832 32.542 0 36.3328 0C45.3068 0 52.5815 7.1634 52.5815 16Z",
    fill: "#F89E1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomark);
export default __webpack_public_path__ + "static/media/logomark.b9088f8c1ebb3b6865af63bba8b968f5.svg";
export { ForwardRef as ReactComponent };